import React, { useEffect, useMemo, useState } from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import { mainApi } from '../../../store/services/mainApi'
import AlbaranPdfPanel from '../../../components/AlbaranPdfPanel/AlbaranPdfPanel'

const OrderPageLogistic = () => {
  const [orderIdParams] = useState(() => location.pathname.split('/').pop())
  const {
    data: orderData,
    isLoading,
    isError,
  } = mainApi.useGetOrdersByIdQuery(orderIdParams, {
    pollingInterval: 50000,
  })

  const [order, setOrder] = useState(orderData)

  useEffect(() => {
    if (orderData) {
      setOrder(orderData)
    }
  }, [orderData])

  if (isLoading && !order) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (isError || !order) return null

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        overflowY: 'auto',
        bgcolor: 'background.paper',
        boxSizing: 'border-box',
        p: 3,
      }}
    >
      <AlbaranPdfPanel
        orderId={order._id}
        tradeName={order?.tradeName}
        order={order}
        title="Print Albaran"
      />
    </Box>
  )
}

export default OrderPageLogistic
